// join the users and stack with the game
export const getGameUsersData = store => {
  const gameUsers = store.games.byId[store.games.currentGame].players;
  const listData = {};

  gameUsers.forEach(userId => {
    listData[userId] = {
      ...store.players.byId[userId]
    };
  });

  return listData;
};

export const getStacksByUser = store => {
  const userList = getGameUsersData(store);

  for (const key in userList) {
    if (userList.hasOwnProperty(key)) {
      const user = userList[key];

      for (const stack in store.stacks.byId) {
        if (store.stacks.byId.hasOwnProperty(stack)) {
          const element = store.stacks.byId[stack];

          if (element.owner === user.id) {
            userList[key] = {
              ...userList[key],
              stacks: {
                ...userList[key].stacks,
                [stack]: store.stacks.byId[stack]
              }
            };
          }
        }
      }
    }
  }

  return userList;
};

export const getUserStacksForRound = (store, userId) => {
  const currentRound = store.rounds.currentRoundId;
  const stacksForRound = {};

  store.rounds.byId[currentRound].stacks.forEach(stackId => {
    if (store.stacks.byId[stackId].owner === userId) {
      stacksForRound[stackId] = { ...store.stacks.byId[stackId] };
    }
  });

  return stacksForRound;
};

//todo somewhere in here need to check for current game
export const getPlayerStacksFullValue = store => {
  //instead use getUserStacksForRound here
  const userList = getStacksByUser(store); //now each user has stacks
  let userValueMapping = {};

  for (const userId in userList) {
    if (userList.hasOwnProperty(userId)) {
      userValueMapping[userId] = 0;
      for (const stackId in userList[userId].stacks) {
        if (
          userList[userId].stacks.hasOwnProperty(stackId) &&
          userList[userId].stacks
        ) {
          userValueMapping[userId] += userList[userId].stacks[stackId].value;

          if (userList[userId].stacks[stackId].goldCount) {
            //todo grab the value from the cardsById
            userValueMapping[userId] +=
              userList[userId].stacks[stackId].goldCount * 50000;
          }

          if (userList[userId].stacks[stackId].silverCount) {
            userValueMapping[userId] +=
              userList[userId].stacks[stackId].silverCount * 25000;
          }
        }
      }
    }
  }

  return userValueMapping;
};

export const IsGameComplete = store => {
  const valuesByPlayer = getPlayerStacksFullValue(store);
  let isGameOver = false;

  for (const userId in valuesByPlayer) {
    if (valuesByPlayer.hasOwnProperty(userId)) {
      if (valuesByPlayer[userId] > 1000000) {
        isGameOver = true;
      }
    }
  }

  return isGameOver;
};

//todo maybe pass in a gameId here?
//will be needed when they can add players from past games
export const getStandings = store => {
  const valuesByPlayer = getPlayerStacksFullValue(store);
  const playerStandings = [];

  for (const userId in valuesByPlayer) {
    if (valuesByPlayer.hasOwnProperty(userId)) {
      playerStandings.push({
        userData: store.players.byId[userId],
        userValue: valuesByPlayer[userId]
      });
    }
  }

  return playerStandings.sort(function(a, b) {
    return b.userValue - a.userValue;
  });
};
